import { Row } from '@tanstack/react-table';
import { memo } from 'react';

import { EventWithDataAndMetrics } from './configs/EventsTableColumnsConfig';

type EventRowWrapperProps = {
  /**
   * Row columns joint with ','
   *
   * Important!!!
   * React.memo track the props, only rerender when the props changes.
   * Dummy prop to force re-render the table row when columns/order changes.
   */
  columns: string;
  /**
   * Same here, checkbox column is controlled via the table state, not the columns
   */
  showCheckbox: boolean;
  rowIndex: number;
  row: Row<EventWithDataAndMetrics | null>;
  getContent: (row: Row<EventWithDataAndMetrics | null>) => React.ReactNode;
};

/**
 * Dummy event row wrapper to memoize the row content, to avoid unnecessary rerender
 */
const EventRowWrapperRaw = ({ getContent, row }: EventRowWrapperProps) => {
  return <>{getContent(row)}</>;
};

// Memoized dummy wrapper to avoid rerender the content on scrolling
export const EventRowWrapper = memo(EventRowWrapperRaw);
